<script lang="ts" setup>
import type { LinkNode } from '@laam/cms-shared';
import { LazyImage } from '../lazy-image';

interface EntityCardProps {
	data: LinkNode;
	shape: 'square' | 'rectangle';
}

defineProps<EntityCardProps>();
</script>
<template>
	<div class="category-card gap-md flex flex-col items-center">
		<div
			class="overflow-hidden w-full h-full rounded-xs bg-gray-100"
			:class="{
				'aspect-square': shape === 'square',
				'aspect-[5/7]': shape === 'rectangle',
			}"
		>
			<LazyImage
				v-if="data.image"
				:src="data.image"
				:fall-back-src="data.fallback_image"
				:alt="data.name"
				width="280"
				provider="shopify"
				class="w-full"
			/>
		</div>

		<h3 class="text-sm font-medium text-center">{{ data.name }}</h3>
	</div>
</template>
